export const NO_CLAIMANT_DATA_LABEL = 'No claimant data';

/**
 * Builds a display name from claimant first/last parts (person or entity).
 * Entity claimants often have only lastName (company name).
 */
export function formatClaimantDisplayName(
    firstName?: string | null,
    lastName?: string | null,
    emptyLabel: string = NO_CLAIMANT_DATA_LABEL,
): string {
    const parts = [firstName, lastName]
        .map((part) => (part == null ? '' : String(part).trim()))
        .filter((part) => part.length > 0);

    return parts.length > 0 ? parts.join(' ') : emptyLabel;
}
